import { config } from '@/shared/lib/config';

let mode: 'bff' | 'keycloak' = config.authMode;

export function isBffMode(): boolean {
  return mode === 'bff';
}

export function fallBackToKeycloak(): void {
  mode = 'keycloak';
}
